import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AccountStateType, AccountSummaryType, TransactionType } from 'src/shared/types/src/lib/invoice.types';

const initialState: AccountStateType = {
    transactionsLoading: false,
    balance: '',
    currency: '£',
    depositAmount: '',
    transactions: [],
    isBillPayer: false,
    paymentMethodsForChild: [],
    paymentMethodsForNursery: [],
    paymentGateway: {
        connected: false,
        type: null
    }
}

const accountSlice = createSlice({
    name: 'accountSlice',
    initialState,
    reducers: {
        setAccountData: (state, action: PayloadAction<AccountSummaryType>) => {
            state.balance = action.payload.balance;
            state.currency = action.payload.currency;
            state.depositAmount = action.payload.depositAmount;
        },
        setTransactionsLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.transactionsLoading = action.payload.isLoading;
        },
        setTransactions: (state, action: PayloadAction<{ transactions: TransactionType[] }>) => {
            state.transactions = action.payload.transactions;
        },
        setBillPayer: (state, action: PayloadAction<{ isBillPayer: boolean }>) => {
            state.isBillPayer = action.payload.isBillPayer;
        },
        setPaymentMethodsForChild: (state, action: PayloadAction<{ availablePaymentMethods: any[] }>) => {
            state.paymentMethodsForChild = action.payload.availablePaymentMethods;
        },
        setPaymentMethodsForNursery: (state, action: PayloadAction<{ availablePaymentMethods: any[] }>) => {
            state.paymentMethodsForNursery = action.payload.availablePaymentMethods;
        },
        setPaymentGatewayConfig: (state, action: PayloadAction<{ paymentGateway: { connected: boolean, type: string | null } }>) => {
            state.paymentGateway = action.payload.paymentGateway;
        },
        resetAccountOnChildChange: (state) => {
            return {
                ...initialState,
                paymentMethodsForNursery: state.paymentMethodsForNursery
            }
        },
        resetTransactions: (state) => {
            return initialState;
        }
    }
});

export const AccountAction = accountSlice.actions;
export default accountSlice.reducer;